import { render } from "./MRDemoVideoPage.vue?vue&type=template&id=20e7b53a&scoped=true"
import script from "./MRDemoVideoPage.vue?vue&type=script&lang=js"
export * from "./MRDemoVideoPage.vue?vue&type=script&lang=js"

import "./MRDemoVideoPage.vue?vue&type=style&index=0&id=20e7b53a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e7b53a"]])

export default __exports__